import {
  getLayout,
  getPaint,
  getStyleType,
  getTextField,
  getRanchPaint,
} from './layerStyler'

export default function ranchApnLayers(map, features) {
  var props = []
  var label = []
  features.features.forEach((polygon) => {
    label = ['parcel_id']
    // if(polygon.geometry.type === "Polygon"){
    //     props = ["PARCEL_APN:APN"]//, "COUNTYNAME:County", "SITE_ADDR:Address", "SITE_CITY:City", "SITE_STATE:State", "SITE_ZIP:Zip", "SITE_PLUS_4:Zip+4", "SITE_HOUSE_NUMBER:House No.", "LATITUDE:Latitude", "LONGITUDE:Longitude"]
    //     label = ["parcel_id"]
    // } else {
    //     props = ["PARCEL_APN:APN"]
    // }
  })

  var ranchApnSource = {
    key: 'Ranch_APN_source',
    id: 'Ranch_APN_source',
    type: 'geojson',
    data: features,
  }

  var ranchApnLayer = {
    id: 'Ranch_APN',
    type: getStyleType('MULTIPOLYGON'),
    source: 'Ranch_APN_source',
    layout: getLayout('MULTIPOLYGON', 'visible'),
    paint: getPaint('MULTIPOLYGON', '#D74C00'),
  }

  var ranchApnOutlineLayer = {
    id: 'Ranch_APN_outline',
    type: 'line',
    source: 'Ranch_APN_source',
    layout: getLayout('OUTLINE', 'visible'),
    paint: {
      'line-color': [
        'case',
        ['has', 'selected'],
        ['get', 'selected'],
        ['has', 'hex'],
        ['get', 'hex'],
        ['to-color', '#D74C00'],
      ],
      'line-width': 4,
    },
  }

  var ranchApnLabelLayer = {
    id: 'Ranch_APN_label',
    type: 'symbol',
    source: 'Ranch_APN_source',
    layout: {
      visibility: 'visible',
      'icon-image': '',
      'text-field': getTextField(label),
      'text-font': ['Roboto Condensed Bold'],
      'text-offset': [0, 0],
      'text-letter-spacing': 0,
      'text-anchor': 'top',
      'text-size': 14,
    },
    paint: {
      'text-color': '#2c2c2c',
      'text-halo-color': '#ffffff',
      'text-halo-width': 2,
    },
  }

  return {
    ranchApnSource,
    ranchApnLayer,
    ranchApnOutlineLayer,
    ranchApnLabelLayer,
  }
}
